import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Header } from "./Header";

export interface ScreenFrameProps {
  children: React.ReactNode;
  contentClassName?: string;
}

export const ScreenFrame = ({
  children,
  contentClassName = "",
}: ScreenFrameProps) => (
  <div className="flex h-screen w-screen min-w-80 flex-col bg-[#191B1F]">
    <Header />
    <div
      className={classNames(
        "flex grow flex-col items-center justify-center",
        contentClassName,
      )}
    >
      {children}
    </div>
  </div>
);
